import React from "react";
import "./SectionOne.scss";
import logo from "../../../../../Assets/Images/Home/Main1/logo.png";

const isKorean = () => {
  const lang =
    (typeof localStorage !== "undefined" && localStorage.getItem("i18nextLng")) || "en";
  return lang === "kr" || lang.startsWith("ko");
};

function SectionOne() {
  const kr = isKorean();

  return (
    <div className="section-one">
      <div className="s1-grid" />

      <div className="section-one-header">
        <div className="section-one-logo">
          <img src={logo} alt="concept cube logo" />
        </div>
        <span className="s1-badge">3D · BIM · DIGITAL TWIN</span>
      </div>

      <div className="section-one-container">
        <div className="section-one-main">
          <h1 className="section-one-title">
            Everything
            <br />
            in <span className="s1-accent">3D</span>.
          </h1>
        </div>
      </div>

      <div className="s1-foot">
        <p className="s1-lead">
          {kr
            ? "컨셉큐브 — 3D 비주얼라이제이션 · BIM · 디지털 트윈 · 미디어 전문 스튜디오"
            : "Concept Cube — a 3D visualization, BIM, digital-twin & media studio."}
        </p>
        <span className="s1-scroll">SCROLL ↓</span>
      </div>
    </div>
  );
}

export default SectionOne;
